<template>
  <button
    class="pin-button"
    :class="[{ pinned: isPinned }, size]"
    @click="handleClick"
    :disabled="disabled"
    :title="getTooltip"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <svg
      v-if="isPinned || (!isPinned && isHovered)"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12.5893 2.79369C11.9327 2.13711 10.8206 2.35128 10.4548 3.20475L9.26037 5.99178C8.13606 5.7713 6.92475 6.09609 6.05257 6.96827L4.77 8.25084C4.55033 8.47051 4.55033 8.82667 4.77 9.04634L6.64148 10.9178L2.60225 14.957C2.38258 15.1767 2.38258 15.5329 2.60225 15.7525C2.82192 15.9722 3.17808 15.9722 3.39775 15.7525L7.43698 11.7133L9.30852 13.5849C9.41401 13.6903 9.55708 13.7496 9.70627 13.7496C9.85545 13.7496 9.99852 13.6903 10.104 13.5849L11.3866 12.3023C12.2588 11.4301 12.5836 10.2188 12.3631 9.09448L15.1501 7.90004C16.0036 7.53427 16.2177 6.42216 15.5612 5.76558L12.5893 2.79369Z"
        fill="#374957"
      />
    </svg>
    <svg
      v-else
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5893 2.79369C11.9327 2.13711 10.8206 2.35128 10.4548 3.20475L9.26037 5.99178C8.13606 5.7713 6.92475 6.09609 6.05257 6.96827L4.77 8.25084C4.55033 8.47051 4.55033 8.82667 4.77 9.04634L6.64148 10.9178L2.60225 14.957C2.38258 15.1767 2.38258 15.5329 2.60225 15.7525C2.82192 15.9722 3.17808 15.9722 3.39775 15.7525L7.43698 11.7133L9.30852 13.5849C9.41401 13.6903 9.55708 13.7496 9.70627 13.7496C9.85545 13.7496 9.99852 13.6903 10.104 13.5849L11.3866 12.3023C12.2588 11.4301 12.5836 10.2188 12.3631 9.09448L15.1501 7.90004C16.0036 7.53427 16.2177 6.42216 15.5612 5.76558L12.5893 2.79369ZM11.4888 3.64791C11.5411 3.52599 11.7 3.49539 11.7938 3.58919L14.7657 6.56108C14.8595 6.65488 14.8289 6.81375 14.7069 6.866L11.4704 8.25307C11.1972 8.37019 11.0622 8.67973 11.1624 8.95965C11.4707 9.82087 11.2791 10.8187 10.5911 11.5068L9.70627 12.3916L5.96324 8.64859L6.84807 7.76377C7.53612 7.07571 8.53398 6.88418 9.3952 7.19244C9.67511 7.29262 9.98466 7.15768 10.1018 6.88442L11.4888 3.64791Z"
        fill="#374957"
      />
    </svg>
  </button>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref } from 'vue';

const props = defineProps({
  isPinned: {
    type: Boolean,
    default: false,
  },
  metricId: {
    type: String,
    default: null,
  },
  size: {
    type: String,
    // small, large
    default: 'small',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  disabledTooltip: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['toggle']);

const isHovered = ref(false);

const getTooltip = computed(() => {
  if (props.disabled && props.disabledTooltip) {
    return props.disabledTooltip;
  }
  return props.isPinned ? 'Unpin' : 'Pin';
});

function handleClick() {
  if (props.disabled) return;
  emit('toggle', props.metricId);
}

function handleMouseEnter() {
  isHovered.value = true;
}

function handleMouseLeave() {
  isHovered.value = false;
}
</script>

<style scoped>
.pin-button {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
  flex-shrink: 0;
}
.pin-button.small {
  width: 18px;
  height: 18px;
}
.pin-button.large {
  width: 24px;
  height: 24px;
}

.pin-button:hover:not(:disabled) {
  background: rgba(0, 72, 121, 0.08);
}

.pin-button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.pin-button.small svg {
  display: block;
  width: 14px;
  height: 14px;
}
.pin-button.large svg {
  display: block;
  width: 18px;
  height: 18px;
}
</style>
